export default __webpack_public_path__ + "static/media/marketing.e8335e09.svg";